import { COUNTRIES_LIST } from "@/Constants/CountriesList";

export const getCountryByAssociation = (value: string) => {
  try {
    let allegedCountry: string;

    if (value?.includes(",")) {
      allegedCountry = value.split(", ")[1];
    } else {
      allegedCountry = value;
    }

    const countryItem = COUNTRIES_LIST.find(
      (countryItem) =>
        countryItem.ISO.toLowerCase() === allegedCountry.toLowerCase() ||
        countryItem.Country.toLowerCase() === allegedCountry.toLowerCase() ||
        countryItem.Alias.some(
          (alias) => alias.toLowerCase() === allegedCountry.toLowerCase(),
        ),
    );

    return countryItem ? countryItem.ISO : null;
  } catch {
    return null;
  }
};
